import '@/installFineMq'
import '@/installCompositionApi'

import Vue from 'vue'

import hateoasIndex from '@/hateoas-index'
import http from '@/helpers/http'
import { mount } from '@/mounter'

import CheckboxGroup from './components/CheckboxGroup'
import SanitasForm from './components/Form'
import HouseKeyError from './components/HouseKeyError'
import HouseKeyModule from './components/HouseKeyModule'
import SanitasInputFile from './components/InputFile'
import SanitasInputWrapper from './components/InputWrapper'
import SanMultiForm from './components/MultiForm'
import PreInsurers from './components/PreInsurers'
import RadioGroupWrapper from './components/RadioGroupWrapper'
import SanitasTooltip from './components/SanitasTooltip'
import Validate from './directives/validate'

Vue.directive('validate', Validate)

const config = window.Sanitas?.SanitasFormsConfig || {}

http.createHateoas({
  name: 'api',
  rootEndpoint: hateoasIndex,
  axiosConfig: {
    baseURL: config.apiUrl || '/public',
  },
})

mount('forms', {
  Feedback: () => {
    return import(
      /* webpackChunkName: "form-component" */
      '@/modules/forms/components/Feedback'
    )
  },
  Icon: () => {
    return import(
      /* webpackChunkName: "sanitas-components" */
      '@/modules/icon/Icon'
    )
  },
  SanitasButton: () => {
    return import(
      /* webpackChunkName: "sanitas-components" */
      '@/components/sanitas-components/SanitasButton'
    )
  },
  RadioGroup: () => {
    return import(
      /* webpackChunkName: "sanitas-components" */
      '@/components/sanitas-components/RadioGroup'
    )
  },
  DateInput: () => {
    return import(
      /* webpackChunkName: "sanitas-components" */
      '@/components/sanitas-components/DateInput'
    )
  },
  TextInput: () => {
    return import(
      /* webpackChunkName: "sanitas-components" */
      '@/components/sanitas-components/TextInput'
    )
  },
  Checkbox: () => {
    return import(
      /* webpackChunkName: "sanitas-components" */
      '@/components/sanitas-components/Checkbox'
    )
  },
  Radio: () => {
    return import(
      /* webpackChunkName: "sanitas-components" */
      '@/components/sanitas-components/Radio'
    )
  },
  PhoneNumberInput: () => {
    return import(
      /* webpackChunkName: "sanitas-components" */
      '@/components/sanitas-components/PhoneNumberInput'
    )
  },
  SanTextArea: () => {
    return import(
      /* webpackChunkName: "sanitas-components" */
      '@/components/sanitas-components/Textarea'
    )
  },
  SanitasInputWrapper,
  SanitasForm,
  CheckboxGroup,
  SanitasTooltip,
  RadioGroupWrapper,
  SanitasInputFile,
  SanMultiForm,
  HouseKeyError,
  HouseKeyModule,
  PreInsurers,
})
